import $ from 'jquery'

$(document).ready(function () {
  dhsv_vc_video_hover_teaser()
})

function dhsv_vc_video_hover_teaser() {
  $('.dhsv_vc_video_hover_teaser').each(function () {
    const $element = $(this)
    const $textContent = $element.find(
      '.dhsv_vc_video_hover_teaser__text-content'
    )
    const $hoverText = $element.find('.dhsv_vc_video_hover_teaser__hover-text')
    const $image = $element.find('.dhsv_vc_video_hover_teaser__image')
    const $overlay = $element.find('.dhsv_vc_video_hover_teaser__video-overlay')

    // Handle hover events
    $element.on('mouseenter', function () {
      $element.addClass('is-hovered')
      $textContent.addClass('is-hidden')
      $image.addClass('is-hidden')
      $hoverText.addClass('is-visible')
      $overlay.addClass('is-darkened')
    })

    $element.on('mouseleave', function () {
      $element.removeClass('is-hovered')
      $textContent.removeClass('is-hidden')
      $image.removeClass('is-hidden')
      $hoverText.removeClass('is-visible')
      $overlay.removeClass('is-darkened')
    })
  })
}
